<!-- payment icons for visa, master.. -->
<div class="payment-icons">
    <div
        style="box-sizing: border-box; display: flex; align-items: center; flex-direction: row; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 0px; min-width: 0px; margin-top: 12px; padding: 0px">
        <svg aria-hidden="true" role="img" width="33" height="22" fill="none" viewBox="0 0 33 22">
            <path fill="#fff" d="M0 0h33v22H0z"></path>
            <path fill="#1434CB"
                  d="m12.89 6.171-3.927 9.371H6.4L4.468 8.064c-.118-.46-.22-.63-.577-.824-.582-.316-1.544-.612-2.391-.796l.058-.273h4.124c.526 0 .999.35 1.118.956l1.02 5.422 2.524-6.378h2.546Zm10.04 6.312c.011-2.474-3.42-2.61-3.395-3.715.007-.336.327-.693 1.028-.785.347-.045 1.304-.08 2.39.42l.425-1.988A6.514 6.514 0 0 0 21.111 6c-2.396 0-4.082 1.274-4.097 3.098-.015 1.349 1.204 2.101 2.122 2.55.945.459 1.262.754 1.259 1.164-.007.629-.754.907-1.452.917-1.218.02-1.925-.33-2.489-.591l-.44 2.053c.567.26 1.613.486 2.696.498 2.547 0 4.213-1.258 4.22-3.206Zm6.328 3.06H31.5L29.543 6.17h-2.07c-.465 0-.857.271-1.03.688l-3.639 8.683h2.546l.505-1.4h3.11l.293 1.4Zm-2.705-3.321 1.276-3.519.735 3.519h-2.01Zm-10.199-6.05-2.004 9.37h-2.424l2.005-9.37h2.423Z"></path>
        </svg>
        <div
            style="box-sizing: border-box; display: flex; align-items: stretch; flex-direction: column; flex-shrink: 0; border-style: solid; border-width: 0px; position: relative; z-index: 0; min-height: 10px; min-width: 0px; background-color: rgba(0, 0, 0, 0); width: 8px;"></div>
        <svg aria-hidden="true" role="img" width="33" height="22" fill="none" viewBox="0 0 33 22">
            <path fill="#FF5F00" d="M20.288 4.198h-7.57v13.6h7.57v-13.6Z"></path>
            <path fill="#EB001B"
                  d="M13.2 10.998a8.705 8.705 0 0 1 3.291-6.8C12.743 1.242 7.288 1.89 4.333 5.664 1.4 9.412 2.05 14.843 5.823 17.798a8.627 8.627 0 0 0 10.692 0 8.654 8.654 0 0 1-3.316-6.8Z"></path>
            <path fill="#F79E1B"
                  d="M30.5 10.998a8.645 8.645 0 0 1-8.65 8.65 8.562 8.562 0 0 1-5.335-1.85c3.749-2.955 4.398-8.386 1.442-12.158-.432-.529-.913-1.034-1.442-1.442 3.749-2.956 9.203-2.307 12.135 1.466a8.561 8.561 0 0 1 1.85 5.334Z"></path>
        </svg>
        
    </div>
</div>

<form [formGroup]="paymentForm">
    <div class="md-form" *ngIf="!hideNameField">
        <input
            type="text"
            mdbInput
            formControlName="nameOnAccount"
            class="form-control validate"
            mdbValidate
            data-private
            data-testid="cardholder-name"
            placeholder=" "
            autocomplete="cc-name"
            id="nameOnAccount"
        />
        <label for="nameOnAccount" class="">Cardholder Name</label>
        <mdb-error *ngIf="hasError('nameOnAccount')" data-testid="cardholder-name-required-error">
            Please enter valid cardholder name.
        </mdb-error>
    </div>

    <div class="md-form">
        <input
            type="text"
            mdbInput
            formControlName="accountNumber"
            class="form-control validate"
            mdbValidate
            data-private
            data-testid="credit-card-number"
            placeholder=" "
            autocomplete="cc-number"
            id="accountNumber"
        />
        <label for="accountNumber" class="">Card Number</label>
        <mdb-error *ngIf="hasError('accountNumber')" data-testid="credit-card-number-required-error">
            Please enter valid card number.
        </mdb-error>
    </div>

    <div class="row">
        <div class="col">
            <div class="md-form">
                <input
                    type="text"
                    mdbInput
                    formControlName="expirationMonth"
                    placeholder="MM"
                    class="form-control validate"
                    mdbValidate
                    data-private
                    data-testid="expiration-month"
                    autocomplete="cc-exp-month"
                    id="expirationMonth"
                />
                <label for="expirationMonth">Month</label>
                <mdb-error *ngIf="hasError('expirationMonth')" data-testid="expiration-month-required-error">
                    Please enter valid month.
                </mdb-error>
            </div>
        </div>
        <div class="col">
            <div class="md-form">
                <input
                    type="text"
                    mdbInput
                    formControlName="expirationYear"
                    placeholder="YYYY"
                    class="form-control validate"
                    mdbValidate
                    data-private
                    data-testid="expiration-year"
                    autocomplete="cc-exp-year"
                    id="expirationYear"
                />
                <label for="expirationYear">Year</label>
                <mdb-error *ngIf="hasError('expirationYear')" data-testid="expiration-year-required-error">
                    Please enter valid year.
                </mdb-error>
            </div>
        </div>

        <div class="col">
            <div class="md-form">
                <input
                    type="text"
                    mdbInput
                    formControlName="cardCode"
                    class="form-control validate"
                    mdbValidate
                    title="CVV2 is 3 digits on the back of Visa/MasterCard or 4 digits on the front of Amex cards."
                    data-private
                    data-testid="cvv-code"
                    placeholder=" "
                    autocomplete="cc-csc"
                    id="cardCode"
                />
                <label for="cardCode">{{ codeLabel }}</label>
                <mdb-error *ngIf="hasError('cardCode')" data-testid="cvv-code-required-error"
                >Please enter valid {{ codeLabel }}.
                </mdb-error
                >
            </div>
        </div>
    </div>
</form>
